import React from "react";
import ViewWrapper from "../ViewWrapper/ViewWrapper";
import WhatCan from "./WhatCan";
// const WhatCan = lazy(() => import("./WhatCan"));

const WhatCanWrapper = () => {
    return (
        <ViewWrapper>
            <WhatCan />
        </ViewWrapper>
    );
};

export default WhatCanWrapper;
